/* LoveLEDLights - Motiv-Bundle Builder
   Alle Texte kommen aus snippets/lllb-texte.liquid ueber data-texts.
   Preise und Prozente formatiert Intl mit data-locale und data-currency. */
window.lllbInit = function () {
  var root = document.getElementById('lllb');
  if (!root || root.dataset.lllbReady) return;
  root.dataset.lllbReady = '1';
  var motifs = JSON.parse(root.querySelector('[data-lllb-motifs]').textContent);
  var tiers  = JSON.parse(root.dataset.tiers);
  var codes  = JSON.parse(root.dataset.codes);
  var T      = JSON.parse(root.dataset.texts);
  var loc    = root.dataset.locale || 'en';
  var waehrung = root.dataset.currency || 'EUR';
  var avail  = motifs.filter(function (m) { return m.available; });

  function t(schluessel, werte) {
    var s = T[schluessel] || '';
    if (werte) {
      for (var k in werte) { s = s.split('{' + k + '}').join(werte[k]); }
    }
    return s;
  }

  var geldFormat, prozentFormat;
  try { geldFormat = new Intl.NumberFormat(loc, { style: 'currency', currency: waehrung }); } catch (e) { geldFormat = null; }
  try { prozentFormat = new Intl.NumberFormat(loc, { style: 'percent', maximumFractionDigits: 0 }); } catch (e) { prozentFormat = null; }

  function eur(c) {
    var wert = c / 100;
    if (geldFormat) return geldFormat.format(wert);
    return wert.toFixed(2) + ' ' + waehrung;
  }
  function pz(pct) {
    if (prozentFormat) return prozentFormat.format(pct / 100);
    return pct + '%';
  }
  /* "Spare {pct}" je Sprache, fuer die Paketkarten. */
  var SPARE = {de:'Spare {pct}',en:'Save {pct}',fr:'Économisez {pct}',es:'Ahorra {pct}',it:'Risparmia {pct}',nl:'Bespaar {pct}',pt:'Poupe {pct}',pl:'Oszczędź {pct}',cs:'Ušetřete {pct}',da:'Spar {pct}',fi:'Säästä {pct}',sv:'Spara {pct}',nb:'Spar {pct}',el:'Κερδίστε {pct}',tr:'{pct} tasarruf',ar:'وفّر {pct}',he:'חסכו {pct}',ja:'{pct}オフ',ko:'{pct} 할인',th:'ประหยัด {pct}',zh:'省 {pct}'};
  function spareVorlage() {
    var k = loc.toLowerCase();
    return SPARE[k] || SPARE[k.split('-')[0]] || SPARE.en;
  }
  function einheit(qty) { return qty === 1 ? T.one : T.many; }

  /* Japanisch, Koreanisch, Chinesisch und Thai setzen zwischen Zahl und
     Zaehleinheit kein Leerzeichen. */
  var ohneLeerzeichen = /^(ja|ko|zh|th)/i.test(loc);
  function menge(qty) {
    return ohneLeerzeichen ? qty + einheit(qty) : qty + ' ' + einheit(qty);
  }

  var el = {
    tiers: root.querySelector('[data-lllb-tiers]'),
    modes: root.querySelector('[data-lllb-modes]'),
    modesBox: root.querySelector('[data-lllb-modes-box]'),
    slots: root.querySelector('[data-lllb-slots]'),
    hint: root.querySelector('[data-lllb-hint]'),
    picker: root.querySelector('[data-lllb-picker]'),
    sheet: root.querySelector('.lllb-sheet'),
    grid: root.querySelector('[data-lllb-grid]'),
    sum: root.querySelector('[data-lllb-sum]'),
    was: root.querySelector('[data-lllb-was]'),
    save: root.querySelector('[data-lllb-save]'),
    atc: root.querySelector('[data-lllb-atc]'),
    atcMain: root.querySelector('[data-lllb-atcmain]'),
    atcSub: root.querySelector('[data-lllb-atcsub]'),
    err: root.querySelector('[data-lllb-err]'),
    l1: root.querySelector('[data-lllb-l1]'),
    l2: root.querySelector('[data-lllb-l2]'),
    totall: root.querySelector('[data-lllb-totall]'),
    sheetTitel: root.querySelector('[data-lllb-sheet]'),
    close: root.querySelector('[data-lllb-close]')
  };

  function beschrifte() {
    if (el.l1) { el.l1.textContent = T.l1; el.tiers.setAttribute('aria-label', T.l1); }
    if (el.l2) { el.l2.textContent = T.l2; el.modes.setAttribute('aria-label', T.l2); }
    var mix = el.modes.querySelector('[data-mode="mix"]');
    var selbst = el.modes.querySelector('[data-mode="self"]');
    if (mix) mix.textContent = T.mix;
    if (selbst) selbst.textContent = T.self;
    if (el.totall) el.totall.textContent = T.total;
    if (el.atcMain) el.atcMain.textContent = T.atc + ' ➜';
    if (el.sheetTitel) el.sheetTitel.textContent = T.sheet;
    if (el.sheet) el.sheet.setAttribute('aria-label', T.sheet);
    if (el.close) el.close.setAttribute('aria-label', T.close);
  }

  function stufeMit(anzahl) {
    for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty === anzahl) return tiers[i]; }
    return null;
  }

  function startStufe() {
    if (window.__lllbStufe) {
      var eigen = stufeMit(window.__lllbStufe);
      if (eigen) return eigen;
    }
    try {
      var p = parseInt(new URL(location.href).searchParams.get('paket') || '', 10);
      if (p) { var gewuenscht = stufeMit(p); if (gewuenscht) return gewuenscht; }
    } catch (e) {}
    return stufeMit(1) || tiers[0];
  }

  var state = { tier: startStufe(), mode: 'self', slots: [] };

  /* Rabatt wie Shopify: Prozentsatz je Position, jeweils auf Cent gerundet. */
  function rabattVon(preise, pct) {
    if (!pct) return 0;
    var s = 0;
    for (var i = 0; i < preise.length; i++) s += Math.round(preise[i] * pct / 100);
    return s;
  }

  function obenGewaehlt() {
    var kandidaten = [];
    try {
      var u = new URL(location.href).searchParams.get('variant');
      if (u) kandidaten.push(u);
    } catch (e) {}
    var felder = document.querySelectorAll('.product-info__block-item[data-block-type="variant-picker"] input:checked, .product-info form [name="id"]');
    for (var f = 0; f < felder.length; f++) {
      if (felder[f].value) kandidaten.push(felder[f].value);
    }
    for (var k = 0; k < kandidaten.length; k++) {
      for (var i = 0; i < motifs.length; i++) {
        if (String(motifs[i].id) === String(kandidaten[k]) && motifs[i].available) return motifs[i];
      }
    }
    return null;
  }
  function fuelleEinzel() {
    if (state.tier.qty !== 1) return;
    var v = obenGewaehlt() || avail[0];
    if (v) state.slots = [v];
  }

  function guenstigste(qty) {
    var s = avail.map(function (m) { return m.price; }).sort(function (a, b) { return a - b; });
    var raus = [];
    for (var i = 0; i < qty; i++) raus.push(s[i % s.length]);
    return raus;
  }
  function chosen() { return state.slots.filter(Boolean); }
  function preiseVon(liste) { return liste.map(function (m) { return m.price; }); }
  function summe(preise) { return preise.reduce(function (a, b) { return a + b; }, 0); }

  function renderTiers() {
    el.tiers.innerHTML = '';
    tiers.forEach(function (tier) {
      var preise = guenstigste(tier.qty);
      var base = summe(preise);
      var now = base - rabattVon(preise, tier.pct);
      var schild = T['tag' + tier.qty] || '';
      var unterzeile = T['sub' + tier.qty] || '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lllb-tier' + (tier.qty === state.tier.qty ? ' is-on' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', tier.qty === state.tier.qty ? 'true' : 'false');
      /* Rechts nur der Rabatt, gross und gruen, mit "Spare" davor (1 Motiv = 0 %). */
      var teile = spareVorlage().split('{pct}');
      var rechts = '<span class="lllb-now" style="display:block;font-size:26px;line-height:1.1;color:var(--lllb-acc)">'
        + (teile[0] ? '<span style="font-size:16px">' + teile[0] + '</span>' : '')
        + pz(tier.pct)
        + (teile[1] ? '<span style="font-size:16px">' + teile[1] + '</span>' : '') + '</span>';
      var unten = unterzeile;
      b.innerHTML = (schild ? '<span class="lllb-tag">' + schild + '</span>' : '') +
        '<span class="lllb-radio"></span>' +
        '<span class="lllb-tier-l"><span class="lllb-qty">' + menge(tier.qty) + '</span>' +
        (unten ? '<span class="lllb-sub">' + unten + '</span>' : '') + '</span>' +
        '<span class="lllb-tier-r">' + rechts + '</span>';
      b.addEventListener('click', function () { setTier(tier); });
      el.tiers.appendChild(b);
    });
  }
  function setTier(tier) {
    state.tier = tier;
    window.__lllbStufe = tier.qty;
    state.slots = state.slots.slice(0, tier.qty);
    while (state.slots.length < tier.qty) state.slots.push(null);
    if (state.mode === 'mix') autoMix();
    fuelleEinzel();
    if (el.modesBox) el.modesBox.style.display = (tier.qty === 1 ? 'none' : '');
    renderTiers(); renderSlots(); renderTotal();
  }
  function syncModeButtons() {
    Array.prototype.forEach.call(el.modes.children, function (x) {
      x.classList.toggle('is-on', x.dataset.mode === state.mode);
    });
  }
  function setMode(mode) {
    state.mode = mode; syncModeButtons();
    if (mode === 'mix') autoMix(); else state.slots = state.slots.map(function () { return null; });
    fuelleEinzel();
    renderSlots(); renderTotal();
  }
  function autoMix() {
    var pool = avail.slice().sort(function (a, b) { return a.price - b.price; });
    state.slots = [];
    for (var i = 0; i < state.tier.qty; i++) state.slots.push(pool[i % pool.length]);
  }
  function renderSlots() {
    el.slots.innerHTML = '';
    state.slots.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lllb-slot' + (m ? ' is-filled' : '');
      b.setAttribute('aria-label', T.one + ' ' + (i + 1) + (m ? ': ' + m.title : ''));
      b.innerHTML = m
        ? '<img src="' + m.img + '" alt="" loading="lazy"><span class="lllb-slot-x" role="presentation">×</span>'
        : '<span class="lllb-slot-plus">+</span><span class="lllb-slot-pick">' + T.pick + '</span>';
      b.addEventListener('click', function (ev) {
        if (ev.target.classList.contains('lllb-slot-x')) {
          state.slots[i] = null; state.mode = 'self'; syncModeButtons();
          renderSlots(); renderTotal();
        } else { openPicker(i); }
      });
      el.slots.appendChild(b);
    });
    el.hint.textContent = state.tier.qty === 1
      ? T.hintSingle
      : t('hintPick', { a: chosen().length, b: state.tier.qty });
  }
  var pickIndex = null;
  function openPicker(i) {
    pickIndex = i; el.grid.innerHTML = '';
    motifs.forEach(function (m) {
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'lllb-card';
      if (!m.available) c.disabled = true;
      c.innerHTML = '<img src="' + m.img + '" alt="" loading="lazy"><span>' + m.title + '</span><em>' + eur(m.price) + '</em>';
      c.addEventListener('click', function () {
        state.slots[pickIndex] = m; state.mode = 'self'; syncModeButtons();
        closePicker(); renderSlots(); renderTotal();
      });
      el.grid.appendChild(c);
    });
    el.picker.hidden = false; document.body.style.overflow = 'hidden';
  }
  function closePicker() { el.picker.hidden = true; document.body.style.overflow = ''; }
  el.picker.addEventListener('click', function (ev) {
    if (ev.target === el.picker || ev.target.hasAttribute('data-lllb-close')) closePicker();
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !el.picker.hidden) closePicker();
  });
  function renderTotal() {
    var picked = chosen();
    var preise = preiseVon(picked);
    var full = summe(preise);
    var off = rabattVon(preise, state.tier.pct);
    var complete = picked.length === state.tier.qty;
    var now = full - off;

    if (picked.length === 0) {
      el.was.textContent = ''; el.sum.textContent = '—';
      el.save.textContent = state.tier.qty === 1
        ? T.chooseOne
        : t('chooseN', { b: state.tier.qty, unit: einheit(state.tier.qty) });
    } else {
      el.was.textContent = (complete && off > 0) ? eur(full) : '';
      el.sum.textContent = complete ? eur(now) : eur(full);
      el.save.textContent = complete
        ? (off > 0 ? t('save', { amt: eur(off), pct: pz(state.tier.pct) }) : '')
        : t('more', { n: state.tier.qty - picked.length, pct: pz(state.tier.pct) });
    }
    el.atc.disabled = !complete;
    el.atcSub.textContent = complete
      ? t('atcDone', { q: state.tier.qty, unit: einheit(state.tier.qty), price: eur(now) })
      : t('atcOpen', { a: picked.length, b: state.tier.qty });
  }
  el.atc.addEventListener('click', function () {
    var picked = chosen();
    if (picked.length !== state.tier.qty) return;
    el.err.hidden = true; el.atc.disabled = true;
    var byId = {};
    picked.forEach(function (m) { byId[m.id] = (byId[m.id] || 0) + 1; });
    var items = Object.keys(byId).map(function (id) {
      var p = state.tier.qty > 1 ? { 'Set': state.tier.qty + 'x' } : {};
      return { id: Number(id), quantity: byId[id], properties: p };
    });
    var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(wurzel + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        var code = codes[String(state.tier.qty)];
        window.location.href = code
          ? wurzel + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(wurzel + 'cart')
          : wurzel + 'cart';
      }).catch(function () {
        el.atc.disabled = false; el.err.hidden = false;
        el.err.textContent = T.err;
      });
  });
  Array.prototype.forEach.call(el.modes.children, function (b) {
    b.addEventListener('click', function () { setMode(b.dataset.mode); });
  });

  window.lllbUebernehmeOben = function () {
    if (state.tier.qty !== 1) return;
    fuelleEinzel(); renderSlots(); renderTotal();
  };

  beschrifte();
  setTier(state.tier);
  setMode('self');
};

if (!window.__lllbVariantenHook) {
  window.__lllbVariantenHook = true;
  var nachfassen = function () {
    [120, 350, 800, 1500].forEach(function (ms) {
      setTimeout(function () {
        if (window.lllbUebernehmeOben) window.lllbUebernehmeOben();
      }, ms);
    });
  };
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('.product-info__block-item[data-block-type="variant-picker"]')) nachfassen();
  }, true);
  window.addEventListener('popstate', nachfassen);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { window.lllbInit(); });
} else {
  window.lllbInit();
}